import {AnyRouteResult} from '@/app/interfaces/routing';

export function getRouteLanguage(route: AnyRouteResult) {
	return route.params.lang as string | undefined;
}
